import React from "react";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Box, Divider, IconButton } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PeopleIcon from "@mui/icons-material/People";
import RedeemIcon from "@mui/icons-material/Redeem";
import PaymentIcon from "@mui/icons-material/Payment";
import logo from "../../static/PPlay_logo.png";

const drawerWidth = 250;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const TrainerSidebar = ({ open, onClose, isMobile }) => {
  const location = useLocation();

  const menuItems = [
    { path: "/affiliatorportal/dashboard", label: "Dashboard", icon: DashboardIcon },
    { path: "/affiliatorportal/commissions", label: "Commissions", icon: AccountBalanceWalletIcon },
    { path: "/affiliatorportal/referrals", label: "Referrals", icon: PeopleIcon },
    { path: "/affiliatorportal/redemptions", label: "Redemptions", icon: RedeemIcon },
    { path: "/affiliatorportal/payment-settings", label: "Payment Settings", icon: PaymentIcon },
  ];

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "#f7f7f7",
        },
      }}
      variant={isMobile ? "temporary" : "persistent"}
      anchor="left"
      open={open}
      onClose={onClose}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
    >
      <DrawerHeader>
        <Box sx={{ display: "flex", justifyContent: "center", flex: 1 }}>
          <img src={logo} alt="PowerPlay" height="28px" />
        </Box>
        {isMobile && (
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
      </DrawerHeader>
      <Divider />
      <List sx={{ padding: "1rem" }}>
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <ListItem
                button
                sx={{
                  mb: 0.5,
                  borderRadius: 1,
                  backgroundColor: isActive ? "primary.main" : "transparent",
                  color: isActive ? "white" : "inherit",
                  "&:hover": {
                    backgroundColor: isActive ? "primary.dark" : "action.hover",
                  },
                }}
              >
                <ListItemIcon sx={{ color: isActive ? "white" : "inherit", minWidth: 40 }}>
                  <Icon />
                </ListItemIcon>
                {item.label}
              </ListItem>
            </Link>
          );
        })}
      </List>
    </Drawer>
  );
};

export default TrainerSidebar;
